import { createReducer } from 'typesafe-actions';
import {
  selectAddress
} from './actions';

const INITIAL_STATE: AddressesState = {
  selected: undefined
};

const addressesReducer = createReducer<AddressesState>(INITIAL_STATE)
  .handleAction(selectAddress, (state, action) => ({
    ...state,
    selected: action.payload,
  }));

export default addressesReducer;
